import React from "react";
import ReactECharts from "echarts-for-react";

const GenericEchart = (props) => {

    return (
        <React.Fragment>
            <div>
                {/* <Card.Body> */}
                <ReactECharts option={props.options} />
                {/* </Card.Body> */}
            </div>
        </React.Fragment>
    );
};
export default GenericEchart;
